import CampaignService from "@/services/CampaignService"

export const fetchCampaign = async ({ commit }, data) => {
  const campaign = await CampaignService.getCampaign(data)
  commit("setCampaign", campaign)

  return campaign
}

export const fetchCampaigns = async ({ commit }, data) => {
  const targets = await CampaignService.getCampaignList(data)
  commit("setCampaigns", targets)

  return targets
}

export const updateCampaign = async ({ commit }, data) => {
  const campaign = await CampaignService.updateCampaign(data)
  commit("setCampaign", campaign)

  return campaign
}

export const fetchTargets = async ({ commit }, id) => {
  const targets = await CampaignService.getTargets(id)
  commit("setTargets", targets)

  return targets
}

export const fetchTargetDetail = async ({ commit }, { id, path, type }) => {
  const targetDetail = await CampaignService.getTargetDetail(id, path, type)

  commit("setTargetDetail", targetDetail)

  return targetDetail
}

export const fetchRuleChains = async ({ commit }, id) => {
  const ruleChains = await CampaignService.getRuleChains(id)
  commit("setRuleChains", ruleChains)

  return ruleChains
}

export const fetchAdvertisers = async ({ commit }, id) => {
  const advertisers = await CampaignService.getAdvertisers(id)
  commit("setAdvertisers", advertisers)

  return advertisers
}

export const fetchInventory = async ({ commit }, data) => {
  const inventory = await CampaignService.getInventory(data)
  commit("setInventory", inventory)

  return inventory
}

export const resetInventory = async ({ commit }) => {
  commit("resetInventory")
}

export const fetchReports = async ({ commit }, data) => {
  const reports = await CampaignService.getReports(data)
  commit("setReports", reports)

  return reports
}

export const resetReports = async ({ commit }) => {
  commit("resetReports")
}

export const fetchAdvertisingDetails = async ({ commit }, id) => {
  const reports = await CampaignService.getAdvertisingDetails(id)
  commit("setAdvertisingDetails", reports)

  return reports
}

export const fetchAdvertisingEnabled = async ({ commit }, id) => {
  const result = await CampaignService.getAdvertisingEnabled(id)

  commit("setAdvertisingEnabled", result)

  return result
}

export const resetAdvertisingDetails = async ({ commit }) => {
  commit("resetAdvertisingDetails")
}

export const resetCampaignData = async ({ commit }) => {
  commit("resetTargets")
  commit("resetTargetDetail")
  commit("resetAdvertisers")
  commit("resetInventory")
  commit("resetAdvertisingDetails")
}
